



















import { Instance } from '@/classes/TayehApi';
import { GetInstanceResponse, TimeScope } from '@/classes/TayehApi/Instance';
import TimePeriodSelect from '@/components/TimePeriodSelect.vue'
import {Vue, Component, Prop, Inject} from 'vue-property-decorator'
	@Component({
		components: {
			TimePeriodSelect
		}
	})
	export default class ShopReportIncome extends Vue {
		@Inject('getInstance')
		getInstance: () => GetInstanceResponse;

		@Prop({default: 'درآمد'})
		title: string;

		private income= 0;
		private growth= 0;

		period: [TimeScope, number] = [TimeScope.DAY, 30]

		async getIncome (period: [TimeScope, number]) {			
			const res = await Instance.getInstanceStatsIncome(this.getInstance().id, period[0], period[1]);
			this.income = res.data.income;
			this.growth = res.data.growth;
		}

		mounted() {
			this.getIncome(this.period);
		}
	}
